import mexico from '../assets/common/mexico.webp'
import usa from '../assets/common/usa.webp'

export const LANGUAGES = [
  {
    key: 'en',
    name: 'English',
    image: usa,
  },
  {
    key: 'es',
    name: 'Español',
    image: mexico,
  },
] as const
